import React, { useEffect, useState } from 'react';
import './DriversComponent.css';
import Sidebar from '../Header&SIdebar/sidebar';
import axios from 'axios';
import AddDriverModal from './AddDriverModal';

const DriversComponent = () => {
  const [drivers, setDrivers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}v1/Drivers/`, {
        headers: {
          'x-api-key': '12345xxa',
        },
      })
      .then((res) => {
        setDrivers(res.data);
      })
      .catch((error) => {
        console.error('Ошибка при получении данных о водителях:', error);
      });
  }, []);

  const handleAdd = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDelete = (driverId) => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}v1/Drivers/${driverId}`, {
        headers: {
          'x-api-key': '12345xxa',
        },
      })
      .then(() => {
        setDrivers(drivers.filter((driver) => driver.id !== driverId));
      })
      .catch((error) => {
        console.error('Ошибка при удалении водителя:', error);
      });
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredDrivers = drivers.filter((driver) =>
    driver.full_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleAddDriver = (formData) => {
    axios
      .post(`${process.env.REACT_APP_API_URL}v1/Drivers/`, formData, {
        headers: {
          'x-api-key': '12345xxa',
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        setDrivers([...drivers, response.data]);
        handleCloseModal();
      })
      .catch((error) => {
        console.error('Ошибка при добавлении водителя:', error);
      });
  };

  return (
    <div className="drivers-container">
      <Sidebar className="sidebar-drivers" />
      <div className="drivers-content">
        <h2 className="drivers-zagolovok">Водители</h2>
        <div className="header-drivers">
          <div className="button-panel">
            <input
              type="text"
              placeholder="Поиск по имени..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="drivers-container-search-input"
            />
            <button onClick={handleAdd}>Добавить</button>
          </div>
        </div>
        <div className="drivers-list">
          {filteredDrivers.map((driver) => (
            <div key={driver.id} className="driver-card">
              <div className="driver-info">
                <span className="driver-name">{driver.full_name}</span>
                <a href={driver.document} target="_blank" rel="noopener noreferrer">
                  <img src="path-to-document-icon" alt="Документы" className="document-icon" />
                </a>
              </div>
              <button onClick={() => handleDelete(driver.id)} className="delete-button">
                Удалить
              </button>
            </div>
          ))}
        </div>
        <AddDriverModal isOpen={isModalOpen} onClose={handleCloseModal} onAddDriver={handleAddDriver} />
      </div>
    </div>
  );
};

export default DriversComponent;
